import API from '..';
const ENTITY = 'chats';

export const fetchAllianceDocumentMessages = (documentId) =>
    API.get(`/api/v1/${ENTITY}/alliance-document/${documentId}`);
export const fetchCreditDocumentMessages = (documentId) =>
    API.get(`/api/v1/${ENTITY}/credit-document/${documentId}`);
export const sendMessage = (chatId, data) =>
    API.post(`/api/v1/${ENTITY}/${chatId}/message/`, data);
